import { useState, useEffect } from "react";

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);

    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    const listener = () => {
      setMatches(media.matches);
    };

    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", listener);
    } else {
      MediaQueryList.addListener(listener);
    }

    return () => {
      if (typeof media.removeEventListener === "function") {
        media.removeEventListener("change", listener);
      } else {
        MediaQueryList.removeListener(listener);
      }
    };
  }, [matches, query]);

  return matches;
}

// export function useMediaQuery(query) {
//   const [matches, setMatches] = useState(false);

//   useEffect(() => {
//     // Crée un MediaQueryList à partir de la requête
//     const mediaQueryList = window.matchMedia(query);
//     const updateMatch = () => setMatches(mediaQueryList.matches);

//     // Met à jour la correspondance initiale
//     updateMatch();

//     // Ajoute un listener avec addEventListener si disponible
//     if (typeof mediaQueryList.addEventListener === "function") {
//       mediaQueryList.addEventListener("change", updateMatch);
//     } else {
//       // Utilise addListener pour la rétrocompatibilité
//       mediaQueryList.addListener(updateMatch);
//     }

//     return () => {
//       // Nettoie le listener avec removeEventListener si disponible
//       if (typeof mediaQueryList.removeEventListener === "function") {
//         mediaQueryList.removeEventListener("change", updateMatch);
//       } else {
//         // Utilise removeListener pour la rétrocompatibilité
//         mediaQueryList.removeListener(updateMatch);
//       }
//     };
//   }, [query]);

//   return matches;
// }
